import Vue from "vue";
import Vuex from "vuex";
import VueCookie from 'vue-cookie'
import apiInterface from "@/api/apiInterface";
import { post, get } from "@/api/axiosConfig";
import { getInfo, getUser,getAreaForSymbol,setCookiesCategory } from "@/api/public";
import enumInfo from "@/api/enum";
const $get = get;
const $post = post;
const $enumInfo=enumInfo.cardhobby
const $interface = apiInterface.Interface;
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    loading: false,
    lang: VueCookie.get("CardLang") || "en", //多语言 - 当前语言类型
    appId: 'CarHobbyWeb',
    appSecret: 'CarHobbyWeb',
    token: '',
    userLog: '',
    shipCode:'CardHobby23',
    areaSymbol:'$'
  },
  mutations: {
    setLoading(state, data) {
      state.loading = data;
    }
  },
  actions: {
    setLoading: () => {
      commit('setLoading', data);
    },
    isToken() {
      let userInfo = getInfo();
      //isToken()
    },
    // 获取买家对应货币符号
    getUserForSymbol(state,value){

      //console.log(state,'state',value)
      let userInfo = getInfo();
      state.state.areaSymbol=getAreaForSymbol(userInfo,value)
      //console.log(state,'state',getAreaForSymbol(userInfo))
    },
    getCookiesCategory(state){
      let isCategory = VueCookie.get("cardCategory");
      if (isCategory != 0 && isCategory != null) {}else{
        setCookiesCategory()
      }
    },
    // 同步卖家端买家端用户信息
    checkUser(ctx) {
      //isToken()
      let userInfo = getInfo();
      if (userInfo) {
        if (userInfo.PointCount) {
          return true;
        } else {
          getUser(userInfo, 0)
          return true;
          //return getUser(userInfo,0)
        }
      }
    }
  },
  getters: {
    getLoading: (state) => {
      return state.loading;
    }
  },
  modules: {}
});



// WEBPACK FOOTER //
// ./src/store/index.js